var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("sp-feature-header", { attrs: { item: _vm.item } }),
      _vm._v(" "),
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("page-content-creator", {
                    attrs: { itemid: _vm.itemid, pos: "top" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _vm.itemid
                    ? _c("node-element-local-tasks", {
                        attrs: { itemid: _vm.itemid },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.notpublished
                    ? _c("div", { staticClass: "messages warning" }, [
                        _vm._v("\n          Not published\n        "),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "page-body" },
        [
          _vm.hasBody
            ? _c("page-content-wysiwg-contentz", { attrs: { item: _vm.item } })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("sp-feature-highlights", {
        attrs: {
          highlights: _vm.highlights,
          "highlights-layout": _vm.highlightsLayout,
        },
      }),
      _vm._v(" "),
      _c("sp-feature-feature", {
        attrs: { "features-style": _vm.featuresStyle, features: _vm.features },
      }),
      _vm._v(" "),
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("page-content-creator", {
                    attrs: { itemid: _vm.itemid, pos: "bottom" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }